import selectEnv from '@sls-react/utils/selectEnv';

export const microBannerPageViewId = selectEnv(155767, 109073);

export const sellerTricksPageViewId = selectEnv(14, 7);
